module.exports = __webpack_public_path__ + "static/media/education-students.14864f0e.jpg";